import { render } from "./StepContacts.vue?vue&type=template&id=24ef2ac0"
import script from "./StepContacts.vue?vue&type=script&lang=js"
export * from "./StepContacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__